export const isObject = (data: unknown): boolean => {
    return typeof data === 'object' && data !== null && !Array.isArray(data)
}

export type NestedObject<T> = {
    [K in keyof T]: T[K] extends object ? NestedObject<T[K]> : T[K]
}

export type NestedKeyOf<T> = T extends object
    ? { [K in keyof T]: T[K] extends object ? `${K & string}.${NestedKeyOf<T[K]>}` : K & string }[keyof T]
    : never

export function getNestedValue<Data, T = unknown>(
    data: Data,
    accessor: NestedKeyOf<Data> | ((obj: Data) => T),
    options?: { fallback?: T }
): T | undefined {
    const fallback = options?.fallback
    if (typeof accessor === 'function') {
        const result = accessor(data)
        return result ?? fallback
    }
    if (typeof accessor === 'string' && accessor.includes('.')) {
        const result = accessor
            .split('.')
            // eslint-disable-next-line typescript/no-unsafe-type-assertion -- the caller names the type its accessor reads
            .reduce<unknown>((acc, key) => (acc ? Reflect.get(Object(acc), key) : undefined), data) as T
        return result ?? fallback
    }
    // eslint-disable-next-line typescript/no-unsafe-type-assertion -- the key comes from the object it indexes
    const result = data[accessor as keyof Data] as T
    return result ?? fallback
}
